import { createSelector } from 'reselect'

const isLogged = state => state.auth.isLogged
const getUser = state => state.auth.user
const getSettings = state => state.auth.settings

export const getIsLogged = createSelector(
  [ isLogged ],
  isLogged => isLogged
)

export const getLoggedUser = createSelector(
  [ getUser ],
  user => user || false
)

export const getSettingsInfo = createSelector(
  [ getUser, getSettings ],
  (user, settings) => {
    if (!user || !settings) return null

    let info = settings.logins
      .filter(el => [ 'email', 'phone' ].indexOf(el.type) !== -1)
      .reduce((obj, item) => {
        obj[item.type] = item.login
        return obj
      }, {})

    info.name = settings.settings.name
    info.surname = settings.settings.surname

    return info
  }
)



// WEBPACK FOOTER //
// ./src/selectors/user.js